export default import.meta.ROLLDOWN_FILE_URL_I7JkJkCtHkb7XszFND871w